import { NgModule } from 'ng-metadata/core';
import {PrmLoginItem} from './loginItem/loginItem.directive';
import {PrmSelfRegistration} from './selfRegistration/selfRegistration.directive'
import {LoginHelpService} from './loginHelp/loginHelp.service';
import {PrmLoginHelp} from './loginHelp/loginHelp.directive';
import {LoginService} from './login.service';
import {PrmLogin} from './login.directive';
import {PrmStandAloneLogin} from './standAloneLogin.directive';
import {PrmUnionCatalogLogin} from "./unionCatalogLogin/unionCatalogLogin.directive";
import {PrmUnionCatalogLoginInstitutionItem} from "./unionCatalogLogin/unionCatalogLoginInstitutionItem/unionCatalogLoginInstitutionItem.directive";
import {UnionCatalogLoginService} from "./unionCatalogLogin/unionCatalogLogin.service";
import {DirectLoginService} from "./unionCatalogLogin/directLogin.service";
import {PrmFormField} from "../../infra/formBuilder/field/formField.directive"
import {SelfRegistrationService} from './selfRegistration/selfRegistration.service';

@NgModule({
    declarations: [
        PrmLogin,
        PrmLoginHelp,
        PrmLoginItem,
        PrmStandAloneLogin,
        PrmUnionCatalogLogin,
        PrmUnionCatalogLoginInstitutionItem,
        PrmSelfRegistration,
        PrmFormField
    ],
    providers: [
        LoginHelpService,
        LoginService,
        UnionCatalogLoginService,
        DirectLoginService,
        SelfRegistrationService
    ],
    imports:[
    ]
})

export class LoginModule{}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/login.module.ts